// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

/**
 * google_conversion.js
 *
 * Asynchronously adds Google's conversion.js to the page by using $.ajax
 * and a "queue" for the tracking pixels.
 *
 * This works by adding a tracking label to the queue with the function
 * M.googleConversion().
 *
 * On window.load, document.write is temporarily overwritten so that it will
 * allow Google's conversion.js to add tracking pixels to the page.
 *
 * The queue is then iterated through. For each element in the queue,
 * window variables (e.g. window.google_conversion_label) are set and
 * conversion.js is loaded. It adds a tracking pixel to the page based on
 * the window variables.
 *
 * After conversion.js is loaded, the queue moves on to the next item, until
 * all items are complete.
 *
 * This allows multiple conversion labels to be loaded asynchronously.
 * Otherwise, the window variables would overwrite each other, causing
 * conversion.js to fail to work for some of them.
 *
 *
 * Usage:
 *
 *   M.googleConversion("labelString");
 *
 */

// Explicitly name global variables for "use strict".
(function(M, _, $) {
  "use strict";

  /**
   * Overwriting document.write
   */

  /**
   * Temporary function to overwrite document.write because Google's
   * conversion.js uses it to add a tracking pixel to the page.
   */
  var newDocumentWrite = function(node) {
    $('body').append(node);
  };
  var oldDocumentWrite = document.write; // Track the native document.write

  /**
   * Overwires the document.write function, which is used by conversion.js
   * to add a tracking pixel.
   */
  var overwriteOldDocumentWrite = function() {
    document.write = newDocumentWrite;
  };

  /**
   * Reverts the document.write function to its old value.
   */
  var revertOldDocumentWrite = function() {
    document.write = oldDocumentWrite;
  };

  /**
   * Queue handling
   *
   * TODO: Abstract this?
   */

  var conversionQueue = []; // Array of adwords labels.
  var queueStarted = false;

  /**
   * Starts the queue if it is not yet started and dequeues the first item.
   */
  var startQueue = function() {
    if (!queueStarted) {
      queueStarted = true;
      dequeue();
    }
  };

  /**
   * Ends the queue only if it has already started.
   */
  var endQueue = function() {
    if (queueStarted) {
      queueStarted = false;
    }
  };

  /**
   * Remove labels from the queue for tracking.
   */
  var dequeue = function() {
    var label = conversionQueue.pop();
    if (!label) {
      // Call endQueue when the queue is empty.
      endQueue();
      return;
    } else {
      // TODO: If abstracting, this behavior needs to change.
      useConversionScript(label, dequeue);
    }
  };

  /**
   * Adds labels to the queue for tracking.
   */
  var enqueue = function(label) {
    conversionQueue.push(label);
  };

  /**
   * Handle Google's conversion.js
   */

  // Google Adwords constants
  var CONVERSION_ID = 1058317835;
  var UNIVERSAL_TRACKING_LABEL = 'hkDbCNXRmAgQi8zS-AM';

  /**
   * Enqueues a request for Google's conversion.js.
   */
  M.googleConversion = function(label) {
    enqueue(label);

    // If M.googleConversion is called after window.load and the
    // queue is already complete, restart the queue.
    // Generally, this should not happen.
    if (windowLoaded && !queueStarted) {
      startQueue();
    }
  };

  /**
   * Loads Google's conversion.js with the proper global variables set
   * to track marketing pixels.
   *
   * @param  {String}   label       Marketing pixel label from Adwords
   * @param  {Function} onComplete  Function called when conversion.js loads
   */
  var useConversionScript = function(label, onComplete) {
    var isUniversalLabel = (label == UNIVERSAL_TRACKING_LABEL);

    // TODO: Clean this up so that all labels have their set of window
    // variables pre-defined in an object literal.
    window.google_conversion_id = CONVERSION_ID;
    window.google_conversion_label = label;
    if (isUniversalLabel) {
      window.google_custom_params = window.google_tag_params;
      window.google_remarketing_only = true;
      window.google_conversion_language = undefined;
      window.google_conversion_format = undefined;
      window.google_conversion_color = undefined;
      window.google_conversion_value = undefined;
    } else {
      window.google_custom_params = undefined;
      window.google_remarketing_only = undefined;
      window.google_conversion_language = 'en';
      window.google_conversion_format = '3';
      window.google_conversion_color = 'ffffff';
      window.google_conversion_value = 0;
    }

    // Use a try-catch to protect the native document.write.
    try {
      overwriteOldDocumentWrite();
      $.ajax({
        url: '//www.googleadservices.com/pagead/conversion.js',
        dataType: 'script',
        cache: true,
        complete: function() {
          revertOldDocumentWrite();
          onComplete();
        }
      });
    } catch(e) {
      revertOldDocumentWrite();
      throw e;
    }
  };

  var windowLoaded = false;

  // Start the queue on page load.
  $(window).load(function() {
    windowLoaded = true;
    startQueue();
  });

})(M, _, $);
